<template>
	<div id="app" class="bg-light">
		<router-view v-if="loaded || $route.path == '/' || $route.path == '/alert' || checkAssesmentUrl() || $route.path == '/assessmentimport' || $route.path == '/hireimport' || $route.path == '/MasterReport' || $route.path == '/interviewimport' || $route.path == '/Login'" @logout="logout" @logoutForExt="logoutForExt" @changeUser="changeUser" :error="error"/>
		<div v-else class="center text-blue">
			<v-icon name="circle-notch" scale="8" spin />
		</div>

		<div v-if="logoutLoader" class="logoutLoader center text-blue" style="z-index:99999;">
			<v-icon name="circle-notch" scale="8" spin />
		</div>
		
	</div>
</template>

<script>
	import { db, auth } from "src/db.js";
	import { mapState } from "vuex";

	export default {
		name: "app",
		computed: {
			userAuth() {
				return auth.currentUser;
			},
			...mapState("firebase", ["convos", "user","prospects"]),
			...mapState("globals", ["limit"])
		},
		methods: {
			async logout() {
				try {
					this.logoutLoader = true;
					localStorage.setItem("authProcess", 0);
					localStorage.setItem("authNumber", '');
					await this.disablePush();
					await auth.signOut();
					this.$store.dispatch('firebase/clearBoundData');
					this.$store.dispatch('globals/CLEAR_ALL');
					localStorage.setItem("authSuccess", 0);
					this.$router.go(0);
				} catch (err) {
					alert(err);
					return;
				}
			},
			async logoutForExt() {
				try {
					this.logoutLoader = true;
					localStorage.setItem("authProcess", 0);
					localStorage.setItem("authNumber", '');
					await this.disablePush();
					await auth.signOut();
					this.$store.dispatch('firebase/clearBoundData');
					this.$store.dispatch('globals/CLEAR_ALL');
					localStorage.setItem("authSuccess", 0);
					// this.$router.go(2);
					this.$router.replace('/Login');
				} catch (err) {
					alert(err);
					return;
				}
			},
			async disablePush() {
				if (this.fcmToken) {
					this.user.fcmTokens[this.fcmToken] = false; //Machine logged out, do not push
					await db.doc(`Users/${this.user.id}`).set(this.user);
				}
			},
			changeUser(value) {
				this.logoutLoader = true;
				this.$store.dispatch('firebase/clearMailsData');
				this.$store.dispatch('firebase/clearCallsData');
				this.$store.dispatch('firebase/clearProsData');
				this.$store.dispatch('firebase/clearConvoData');
				this.$store.dispatch('firebase/rebindProspectsNew', value.Uid);

				this.fetchConvoData(value.Uid);
				
				this.$store.dispatch("firebase/bindUserData", value.Uid)
				// this.$store.dispatch('firebase/rebindConvosCount', value.Uid)
				// .then(() => {
				// 	//eslint-disable-next-line
				// 	console.log("Conversation count:", this.$store.state.firebase.convosCount);

				// 	const totalRecords = this.$store.state.firebase.convosCount; // Total number of records
				// 	const recordsPerPage = 100; // Number of records per page
				// 	const totalPages = Math.ceil(totalRecords / recordsPerPage); // Calculate total pages
				// 	//eslint-disable-next-line
				// 	console.log(`Total Pages: ${totalPages}`); // Output: 7

				// 	for (let page = 1; page <= totalPages; page++) {
				// 		const startRecord = (page - 1) * recordsPerPage + 1;
				// 		const endRecord = Math.min(page * recordsPerPage, totalRecords); // Ensure it doesn't exceed total records
				// 		//eslint-disable-next-line
				// 		console.log(`Page ${page}: Records ${startRecord} to ${endRecord}`);
				// 	}
				// })
				.then(() => {
					if(this.$router.currentRoute.path == '/home/ReportingPage') {
						if(this.user.Version == 2) {
							this.$router.push('/home/ReportingPagev2'); 
						}
					}
					if(this.$router.currentRoute.path == '/home/ReportingPagev2') {
						if(typeof this.user.Version === 'undefined' || this.user.Version == 1) {
							this.$router.push('/home/ReportingPage'); 
						}
					}
					this.logoutLoader = false;
					this.loaded = true;
				})
				.catch((err) => {
					//eslint-disable-next-line
					console.log(err);
				});
			},
			checkAssesmentUrl() {
				let val = false;
				if (this.$route.path.indexOf('/assessment/') > -1 && Object.keys(this.$route.params).length) {
					val = true;
				}
				return val;
			},
			fetchConvoData(uid) {
                //eslint-disable-next-line
                console.log('userAuth.uid:', uid);
                this.$store.dispatch('firebase/rebindConvosNew', {uid:uid, page:this.currentPage, limit:this.limit})
                .then(() => {
                    //eslint-disable-next-line
                    console.log('Data Successfully Fetched A');
                })
                .catch((err) => {
                    //eslint-disable-next-line
                    console.error('Error fetching conversation data:', err);
                });
            }
		},
		watch: {
			userAuth: {
				immediate: true,
				handler(userAuth) {
					if (userAuth) {
						userAuth.getIdTokenResult().then(idTokenResult => {
							this.$store.commit("firebase/SET", {
								var: "userClaims",
								val: idTokenResult.claims
							});
							if (!idTokenResult.claims.admin) {
								this.$store.dispatch('firebase/rebindProspectsNew', userAuth.uid);
								this.fetchConvoData(userAuth.uid);
								
								// let currentPage = 1;
								// // let perPage = 20;
								// //eslint-disable-next-line
								// console.log('userAuth.uid:', userAuth.uid);
								// this.$store.dispatch('firebase/rebindConvosNew', {uid:userAuth.uid, page:currentPage, limit:this.limit})
								// .then(() => {
								// 	//eslint-disable-next-line
								// 	console.log('Los:');
								// })
								// .catch((err) => {
								// 	//eslint-disable-next-line
								// 	console.error('Error fetching conversation count:', err);
								// });

								// this.$store.dispatch('firebase/rebindConvos', userAuth.uid);
								// this.$store.dispatch('firebase/rebindConvosCount', userAuth.uid)
								// .then(() => {
								// 	//eslint-disable-next-line
								// 	console.log("Conversation count:", this.$store.state.firebase.convosCount);

								// 	const totalRecords = this.$store.state.firebase.convosCount; // Total number of records
								// 	const recordsPerPage = 100; // Number of records per page
								// 	const totalPages = Math.ceil(totalRecords / recordsPerPage); // Calculate total pages
								// 	//eslint-disable-next-line
								// 	console.log(`Total Pages: ${totalPages}`); // Output: 7

								// 	for (let page = 1; page <= totalPages; page++) {
								// 		const startRecord = (page - 1) * recordsPerPage + 1;
								// 		const endRecord = Math.min(page * recordsPerPage, totalRecords); // Ensure it doesn't exceed total records
								// 		//eslint-disable-next-line
								// 		console.log(`Page ${page}: Records ${startRecord} to ${endRecord}`);
								// 	}

								// })
								// .catch((err) => {
								// 	//eslint-disable-next-line
								// 	console.error('Error fetching conversation count:', err);
								// });
								this.$store
								.dispatch("firebase/bindUserData", userAuth.uid)
								.then(() => {
									this.loaded = true;
								})
								.catch((err) => {
									this.error = err.message;
									this.$router.push('/alert');
								});
							} else {
								this.$store
								.dispatch("firebase/bindAdminData", userAuth.uid)
								.catch(err => {
									this.error = err;
								});
							}
						});
					}
				}
			},
			convos: {
				handler(convos) {
					if (convos && document.visibilityState == "hidden") {
						document.querySelector("link[rel='shortcut icon']").href = "/favicon_unread.png";
					}
				}
			}
		},
		data() {
			return {
				loaded: false,
				error: null,
				logoutLoader: false,
				currentPage: 1,
			}
		},
		mounted() {
			window.onresize = () => {
				this.$store.commit('globals/SET', { var: 'vw', val: window.innerWidth });
			}
		},
		created() {
			if(localStorage.getItem("authProcess") == 2) {
				if (!this.userAuth && this.$route.path !== '/' && !this.checkAssesmentUrl() && this.$route.path !== '/assessmentimport' && this.$route.path !== '/hireimport' && this.$route.path !== '/MasterReport' && this.$route.path !== '/interviewimport') {
					this.$router.push('/?redirect=' + this.$route.path);
				} else {
					// IF I HAVE ALREADY LOGGED IN AND GO TO BASE URL
					if (this.$route.path == '/') {
						this.$router.push('/home/Conversations');
					}
				}
			} else {
				if(this.$route.path == '/Login'){
					this.$router.push('/Login');
				}
				else if (this.$route.path !== '/' && !this.checkAssesmentUrl() && this.$route.path !== '/assessmentimport' && this.$route.path !== '/hireimport' && this.$route.path !== '/MasterReport' && this.$route.path !== '/interviewimport') {
					this.$router.push('/?redirect=' + this.$route.path)
				}
			}

			// The following logic is written to maintain authentication - If the user is already logged in without encountering the 2FA logic 
			if(auth.currentUser && localStorage.getItem("authProcess") === null) {
				localStorage.setItem("authProcess", 2);
				this.$router.push('/home/Conversations');
			}

		}
	};
</script>

<style>
	.logoutLoader{
		background: #f9f9f9;
		text-align: center;
		vertical-align: middle;
		width: 100%;
		height: 100vh;
		padding-top: 18%;
	}
	.disabled,
	*:disabled {
		background-color: rgb(233, 236, 239);
		border-color: rgb(206, 212, 218);
		color: rgb(73, 80, 87);
	}
	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		padding: 0;
		font-family: arial, sans-serif;
		height: 100vh;
	}
	.popUp {
		border: 1px solid lightgray;
		background-color: white;
		position: absolute;
		box-shadow: 2px 2px 5px gray;
		z-index: 100;
	}
	.blue {
		background-color: #042B79;
	}
	.text-blue {
		color: #042B79;
	}
	.text-gray {
		color: gray;
	}
	.text-red {
		color: rgb(217, 96, 96);
	}
	.center {
		margin: 0;
		position: absolute;
		top: 50%;
		left: 50%;
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
	}
	.center-vert {
		margin: 0;
		position: absolute;
		top: 50%;
		-ms-transform: translateY(-50%);
		transform: translateY(-50%);
	}
	.center-horiz {
		margin: 0;
		position: absolute;
		left: 50%;
		-ms-transform: translateX(-50%);
		transform: translateX(-50%);
	}
	.w-10 {
		width: 10%;
	}
	.w-20 {
		width: 20%;
	}
	.w-30 {
		width: 30%;
	}
	.w-40 {
		width: 40%;
	}
	.w-60 {
		width: 60%;
	}
	.w-70 {
		width: 70%;
	}
	.w-80 {
		width: 80%;
	}
	.w-90 {
		width: 90% !important;
	}
	.h-10 {
		height: 10%;
	}
	.h-20 {
		height: 20%;
	}
	.h-30 {
		height: 30%;
	}
	.h-40 {
		height: 40%;
	}
	.h-60 {
		height: 60%;
	}
	.h-70 {
		height: 70%;
	}
	.h-80 {
		height: 80%;
	}
	.h-90 {
		height: 90%;
	}
	.overflowY-hidden {
		overflow-y: hidden;
	}
	.overflowX-hidden {
		overflow-x: hidden;
	}
	.overflowY-auto {
		overflow-y: auto;
	}
	.overflowX-auto {
		overflow-x: auto;
	}
	.pointer {
		cursor: pointer;
	}
	button.deviceProsInfoTab{
		display: none;
	}
	#priorityModal___BV_modal_outer_{
		z-index: 9999!important;
	}
	.msglogdiv{
		z-index: 999;
	}
	.grpmsglogdiv{
		z-index: 999;
	}
	#TemplateModal___BV_modal_outer_{
		z-index: 99999 !important;
	}



	/* Extra small devices (phones, 600px and down) */
	@media only screen and (max-width: 600px) {
	}

	/* Small devices (portrait tablets and large phones, 600px and up) */
	@media only screen and (min-width: 600px) {
	}

	/* Medium devices (landscape tablets, 768px and up) */
	@media only screen and (min-width: 768px) {
	}

	/* Large devices (laptops/desktops, 992px and up) */
	@media only screen and (min-width: 1030px) {
		#Nav {
			position: relative !important;
		}
		#Title {
			position: relative !important;
			visibility: visible !important;
		}
		#ConvoList {
			position: relative !important;
			width: 29em !important;
			z-index: 999 !important;
			height: auto !important;
		}
		#groupConvoList {
			position: relative !important;
			width: 29em !important;
			z-index: 999 !important;
			height: auto !important;
		}
		#Prospect {
			position: relative !important;
			width: 35em !important;
			z-index: 999 !important;
			height: auto !important;
		}
		#ConvoBackButton {
			position: absolute !important;
			visibility: hidden !important;
		}
		#Templates,
		#Campaigns {
			display: flex;
			flex-direction: row;
		}
		#Templates .module1,
		#Campaigns .module1 {
			min-width: 35%;
			max-width: 35%;
		}
		#Templates .module2,
		#Campaigns .module2 {
			flex-grow: 1;
		}

	}
	.twemoji-textarea-outer > #twemoji-textarea {
		max-height: 100px;
	}

	/* Extra large devices (large laptops and desktops, 1200px and up) */
	@media only screen and (min-width: 1200px) {
	}


/* ADD NEW MEDIA QUERY FOR CONVERSATIONS MODULE */	
/* MOBILE */
@media (max-width:450px) {
    .titlePI{
        font-size: 16px;
        margin-bottom: 15px;
    }
    button.deviceProsInfoTab{
        display: block;
    }
    #ConvoBackButton{
        padding-left: 0px;
    }
	#MessageLog .msglogdiv{
		z-index: 9999;
	}
	#grpMessageLog .grpmsglogdiv{
		z-index: 9999;
	}
	.btn-group.mobilemegoptn{
		display: block;
	}
	div.d-flex.desktopmegoptn{
		display: none!important;
	}
}

@media(min-width:451px) and (max-width:540px) {
    .titlePI{
        font-size: 16px;
        margin-bottom: 15px;
    }
    button.deviceProsInfoTab{
        display: block;
    }
    #ConvoBackButton{
        padding-left: 0px;
    }
	#MessageLog .msglogdiv{
		z-index: 9999;
	}
	#grpMessageLog .grpmsglogdiv{
		z-index: 9999;
	}
	.btn-group.mobilemegoptn{
		display: block;
	}
	div.d-flex.desktopmegoptn{
		display: none!important;
	}
}

@media(min-width:360px) and (max-width:640px) {
    .titlePI{
        font-size: 16px;
        margin-bottom: 15px;
    }
    button.deviceProsInfoTab{
        display: block;
    }
    #ConvoBackButton{
        padding-left: 0px;
    }
	#MessageLog .msglogdiv{
		z-index: 9999;
	}
	#grpMessageLog .grpmsglogdiv{
		z-index: 9999;
	}
	.btn-group.mobilemegoptn{
		display: block;
	}
	div.d-flex.desktopmegoptn{
		display: none!important;
	}
}

/* IPAD */
@media(min-width:541px) and (max-width:768px) {
	#onlyDesktop{
		display: flex !important;
	}
	#onlyDesktop1{
		display: flex !important;
	}
	.btn-group.mobilemegoptn{
		display: block;
	}
	div.d-flex.desktopmegoptn{
		display: none!important;
	}
    .forIpadUIConvo{
		width: 50%;
	}
	.forIpadUIConvo #ConvoList, .forIpadUIConvo #groupConvoList{
		position: inherit;
	}
	button.deviceProsInfoTab{
        display: block;
    }
	#Prospect{
		z-index: 0;
	}
}

@media(min-width:769px) and (max-width:1024px) {
	#onlyDesktop{
		display: flex !important;
	}
	#onlyDesktop1{
		display: flex !important;
	}
	.btn-group.mobilemegoptn{
		display: block;
	}
	div.d-flex.desktopmegoptn{
		display: none!important;
	}
    .forIpadUIConvo{
		width: 50%;
	}
	.forIpadUIConvo #ConvoList, .forIpadUIConvo #groupConvoList{
		position: inherit;
	}
	button.deviceProsInfoTab{
        display: block;
    }
	#Prospect{
		z-index: 0;
	}
}

/* LARGE SCREEN */
@media(min-width:1025px) and (max-width:1200px) {
    
	#onlyDesktop{
		display: flex !important;
	}
	#onlyDesktop1{
		display: flex !important;
	}
	.btn-group.mobilemegoptn{
		display: block;
	}
	div.d-flex.desktopmegoptn{
		display: none!important;
	}
}

@media(min-width : 1201px) {

}
@media(min-width : 769px) and (max-width: 1368px) {
	#onlyDesktop{
		display: flex !important;
	}
	#onlyDesktop1{
		display: flex !important;
	}
	.btn-group.mobilemegoptn{
		display: block;
	}
	div.d-flex.desktopmegoptn{
		display: none!important;
	}
}

/* NARROW BROWSER */
@media(min-width:280px) and (max-width:670px) {
	#onlyDesktop{
		display: flex !important;
	}
	#onlyDesktop1{
		display: flex !important;
	}
	#MessageLog{
		overflow-y: scroll;
	}
	#ConvoItem .plforUI{
		padding-left: 20px;
	}
	.btn-group.mobilemegoptn{
		display: block;
	}
	div.d-flex.desktopmegoptn{
		display: none!important;
	}
	.narrowUI div#twemoji-textarea{
		margin: 10px 2px 10px 0px;
	}
	button#btn-emoji-default{
		margin-right: 0px;
	}
}

</style>
